import React from 'react';

import { FULL_ATTACHMENT_ACCESS, type AttachmentAccess } from 'react-hooks';

import { Flex } from 'components';

import {
  AttachmentData,
  PMAttachments,
  SelectFileReturnType,
} from '../PMAttachments';

import styles from './ScheduleAttachments.scss';

interface ScheduleAttachmentsProps {
  attachmentFiles: AttachmentData[];
  onAddAttachments: SelectFileReturnType;
  onRemoveAttachment: (index: string) => void;
  attachmentAccess?: AttachmentAccess;
}

export const ScheduleAttachments = ({
  attachmentFiles,
  onAddAttachments,
  onRemoveAttachment,
  attachmentAccess = FULL_ATTACHMENT_ACCESS,
}: ScheduleAttachmentsProps) => {
  return (
    <Flex direction="column" className={styles.attachmentSection}>
      <PMAttachments
        attachmentFiles={attachmentFiles}
        onAddAttachments={onAddAttachments}
        onRemoveAttachment={onRemoveAttachment}
        attachmentAccess={attachmentAccess}
      />
    </Flex>
  );
};
